export default __webpack_public_path__ + "static/media/logo3_white.720d5a38.svg";